// extracted by mini-css-extract-plugin
module.exports = {"loadingScreen":"LoadingScreen__loadingScreen__mJN0h","loadingElements":"LoadingScreen__loadingElements__3Au3s"};